import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import AuthCallback from './components/AuthCallback';
import DashboardLayout from './components/DashboardLayout';
import LoginPage from './pages/LoginPage';
import DashboardPage from './pages/DashboardPage';
import ResponseLogPage from './pages/ResponseLogPage';
import ResponseDetailPage from './pages/ResponseDetailPage';
import DealershipsPage from './pages/DealershipsPage';
import TemplatesPage from './pages/TemplatesPage';
import ReportingPage from './pages/ReportingPage';
import RepositoryPage from './pages/RepositoryPage';
import SettingsPage from './pages/SettingsPage';
import VinSolutionsPage from './pages/VinSolutionsPage';
import SchedulingPage from './pages/SchedulingPage';
import SamplesPage from './pages/SamplesPage';
import DeactivatedDealershipsPage from './pages/DeactivatedDealershipsPage';
import PortalLoginPage from './pages/PortalLoginPage';
import PortalRegisterPage from './pages/PortalRegisterPage';
import PortalDashboard from './pages/PortalDashboard';
import './App.css';

function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen bg-[#050505] flex items-center justify-center">
        <div className="text-center">
          <div className="w-8 h-8 border-2 border-red-600 border-t-transparent rounded-full animate-spin mx-auto mb-4" />
          <p className="text-slate-400 text-sm font-medium tracking-wider uppercase">Loading...</p>
        </div>
      </div>
    );
  }

  if (!user) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return <DashboardLayout>{children}</DashboardLayout>;
}

function AppRouter() {
  const location = useLocation();

  // CRITICAL: Detect session_id during render (NOT in useEffect)
  // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }

  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route path="/dashboard" element={<ProtectedRoute><DashboardPage /></ProtectedRoute>} />
      <Route path="/responses" element={<ProtectedRoute><ResponseLogPage /></ProtectedRoute>} />
      <Route path="/responses/:leadId" element={<ProtectedRoute><ResponseDetailPage /></ProtectedRoute>} />
      <Route path="/dealerships" element={<ProtectedRoute><DealershipsPage /></ProtectedRoute>} />
      <Route path="/deactivated" element={<ProtectedRoute><DeactivatedDealershipsPage /></ProtectedRoute>} />
      <Route path="/templates" element={<ProtectedRoute><TemplatesPage /></ProtectedRoute>} />
      <Route path="/reporting" element={<ProtectedRoute><ReportingPage /></ProtectedRoute>} />
      <Route path="/repository" element={<ProtectedRoute><RepositoryPage /></ProtectedRoute>} />
      <Route path="/vinsolutions" element={<ProtectedRoute><VinSolutionsPage /></ProtectedRoute>} />
      <Route path="/scheduling" element={<ProtectedRoute><SchedulingPage /></ProtectedRoute>} />
      <Route path="/samples" element={<ProtectedRoute><SamplesPage /></ProtectedRoute>} />
      <Route path="/settings" element={<ProtectedRoute><SettingsPage /></ProtectedRoute>} />
      <Route path="/portal/login" element={<PortalLoginPage />} />
      <Route path="/portal/register" element={<PortalRegisterPage />} />
      <Route path="/portal/*" element={<PortalDashboard />} />
      <Route path="*" element={<Navigate to="/dashboard" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRouter />
      </AuthProvider>
    </BrowserRouter>
  );
}

export default App;
